import createIcon from '../../createIcon';

/**
 * @component @name ContactEmergency
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgM0gyQzAuOSAzIDAgMy45IDAgNVYxOUMwIDIwLjEgMC45IDIxIDIgMjFIMjJDMjMuMSAyMSAyMy45OSAyMC4xIDIzLjk5IDE5TDI0IDVDMjQgMy45IDIzLjEgMyAyMiAzWk05IDhDMTAuNjUgOCAxMiA5LjM1IDEyIDExQzEyIDEyLjY1IDEwLjY1IDE0IDkgMTRDNy4zNSAxNCA2IDEyLjY1IDYgMTFDNiA5LjM1IDcuMzUgOCA5IDhaTTIuMDggMTlDMy40NiAxNi42MSA2LjA0IDE1IDkgMTVDMTEuOTYgMTUgMTQuNTQgMTYuNjEgMTUuOTIgMTlIMi4wOFpNMjAuOTcgOS44NUwyMC4yMiAxMS4xNUwxOC43NSAxMC4zVjEySDE3LjI1VjEwLjNMMTUuNzggMTEuMTVMMTUuMDMgOS44NUwxNi41IDlMMTUuMDMgOC4xNUwxNS43OCA2Ljg1TDE3LjI1IDcuN1Y2SDE4Ljc1VjcuN0wyMC4yMiA2Ljg1TDIwLjk3IDguMTVMMTkuNSA5TDIwLjk3IDkuODVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ContactEmergency = createIcon('ContactEmergency', [
  [
    'path',
    {
      d: 'M22 3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H22C23.1 21 23.99 20.1 23.99 19L24 5C24 3.9 23.1 3 22 3ZM9 8C10.65 8 12 9.35 12 11C12 12.65 10.65 14 9 14C7.35 14 6 12.65 6 11C6 9.35 7.35 8 9 8ZM2.08 19C3.46 16.61 6.04 15 9 15C11.96 15 14.54 16.61 15.92 19H2.08ZM20.97 9.85L20.22 11.15L18.75 10.3V12H17.25V10.3L15.78 11.15L15.03 9.85L16.5 9L15.03 8.15L15.78 6.85L17.25 7.7V6H18.75V7.7L20.22 6.85L20.97 8.15L19.5 9L20.97 9.85Z',
      key: '1hjoec',
    },
  ],
]);

export default ContactEmergency;
